<template>
  <div class="table-responsive table-wrapper">
    <div class="row form-inline">
      <div class="col-sm-6">
        <label>
          <select class="form-control input-sm" v-model="limit" @change="fetchItems(0)">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>&nbsp;
          Einträge anzeigen
        </label>
      </div>
      <div class="col-sm-6">
        <div class="table-filter">
          <label>
            Suchen &nbsp;
            <b-input @keyup.native="debounceFilter" v-model="filter" name="filter" autocomplete="false" ></b-input>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-striped">
          <thead>
          <tr>
            <th v-for="column in columns" :column="column.column" @click="!column.order || changeOrder(column)" :class="{'cursor-pointer': column.order}">
              {{ $t('table_heads.' + model.entity + '.' + column.key) }}
              <i v-if="column.order" class="fa" :class="{ 'fa-sort': order[column.column] === undefined, 'fa-sort-amount-asc': order[column.column] === 'asc', 'fa-sort-amount-desc': order[column.column] === 'desc' }"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" testclick="$router.push({name: 'domains-single', params: { name: item.name}})" >
            <td v-for="column in columns">
              <div v-if="!column.slot">
                <!-- FORMAT if € | DATETIME-->
                <div v-if="column.format === 'currency'">
                  {{$options.filters[column.format](item[column.key])}}
                </div>
                <div v-else>
                  {{ item[column.key] }}
                </div>
              </div>
              <div v-else>
                <slot name="actions" v-bind:item="item"></slot>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div class="info" v-if="this.fetched">
          {{ this.items.length > 0 ? offset+1 : 0 }} bis {{ recordsFiltered > offset+limit ? offset+limit : recordsFiltered }} von {{ formatNumber(recordsFiltered) }} Einträgen <span v-if="recordsFiltered !== recordsTotal">(gefiltert von {{ formatNumber(recordsTotal) }} Einträgen)</span>
        </div>
      </div>
      <div class="col-sm-7" style="text-align: right">
        <div class="paginate" style="display: inline-block;">
          <ul class="pagination">
            <li :class="{disabled: page <= 0}" @click.prevent="page <= 0 || fetchItems(page-1)" :disabled="page === 0"><a>Zurück</a></li>

            <li v-for="n in showPages" :class="{active: page === (n-1), disabled: !n}" @click="page === (n-1) || !n || fetchItems(n-1)" ><a>{{ n || '...' }}</a></li>

            <li :class="{disabled: page+1 >= pages}" @click.prevent="page+1 >= pages || fetchItems(page+1)"><a>Nächste</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "@/store/vue-axios"
  import {default as _, debounce} from "lodash"
  import {Domain} from "@/store/models/domain/domain";

  export default {
    name: "luma-table",
    props: {
      url: String,
      columns: {
        default: () => ([]),
        type: Array
      },
      order: {
        default: () => ({}),
        type: Object
      },
      model: {
        default: null
      },
      customFilter: Object
    },
    data: () => ({
      limit: 10,
      items: [],
      recordsTotal: null,
      recordsFiltered: null,
      recordsResult: null,
      page: null,
      offset: null,
      filter: null,
      showPages: [],
      // order: {},
      fetched: false
    }),
    directives: {debounce},
    computed: {
      pages() {
        return Math.ceil(this.recordsFiltered / this.limit)
      }
    },
    methods: {
      debounceFilter: debounce(function () {
        this.fetchItems(0)
      }, 200),
      fetchItems: async function (page) {
        if (!this.url) return

        let filterTerm = this.filter

        let filter = {
          connector: 'OR',
          fields: []
        }
        if (this.filter) {
          _.forEach(this.columns, function (value) {
            if (!value.filter)
              return

            filter.fields.push({
              key: value.column,
              operator: 'LIKE',
              value: '%' + filterTerm + '%'
            })
          })
        }

        const filters = [
          filter,
          this.customFilter
        ]

        const result = await axios.get(this.url, {
          params: {
            limit: this.limit,
            offset: page * this.limit,
            filter: {
              connector: 'AND',
              fields: filters
            },
            order: this.order
          }
        })

        this.items = result.data[this.model.apiEntity || this.model.entity]
          console.log('LUMADATATABLE ITEMS:::',this.items)
        this.recordsTotal = parseInt(result.data.recordsTotal)
        this.recordsFiltered = parseInt(result.data.recordsFiltered)
        this.recordsResult = parseInt(result.data.recordsResult)
        this.page = parseInt(page)
        this.offset = parseInt(result.data.offset)
        this.limit = parseInt(this.limit)

        this.fetched = true

        this.model.insertOrUpdate({data: Object.values(this.items)})

          // NAMESERVER TRANSFORM REPAIR !!!!!!!!
          console.log('ITEM NAMESERVER', this.items)
          // this.items.map((item)=>{
          //     Domain.namserverTransformation(item.nameservers, item.name)
          // })

        this.calculatePages()
      },
      calculatePages() {
        var current = this.page,
          last = this.pages,
          delta = 3,
          left = current - delta,
          right = current + delta + 1,
          range = [],
          rangeWithDots = [],
          l;

        for (let i = 1; i <= last; i++) {
          if (i === 1 || i === last || i >= left && i < right) {
            range.push(i);
          }
        }

        for (let i of range) {
          if (l) {
            if (i - l === 2) {
              rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
              rangeWithDots.push(null);
            }
          }
          rangeWithDots.push(i);
          l = i;
        }

        this.showPages = rangeWithDots
      },
      changeOrder(column) {
        const currentOrder = this.order[column.column]

        const direction = !currentOrder || currentOrder === 'desc' ? 'asc' : 'desc'

        this.order = {}
        this.order[column.column] = direction

        this.fetchItems(0)
      }
    },
    created() {
      this.fetchItems(0)
    }
  }
</script>

<style scoped>
  .table-wrapper label {
    font-weight: normal;
    text-align: left;
    display: inline-block;
  }

  .table-wrapper thead th i {
    float: right;
  }

  .table-wrapper .info {
    padding-top: 8px;
    white-space: nowrap;
  }

  .table-wrapper .pagination li:first-child a {
    margin-left: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .table-wrapper .pagination li.active a {
    background-color: #f4f4f4;
    border-color: #DDDDDD;
    color: inherit;
    cursor: default;
    z-index: 2;
  }

  .table-wrapper .pagination .disabled a {
    color: #777;
    cursor: not-allowed;
    background-color: #fff;
    border-color: #ddd;
  }

  .table-filter, .pagination {
    text-align: right;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/LumaDatatable.vue